import { EncryptedObjectIdString } from '../types/common';
import { isEncryptedObjectIdString } from './simpleFormId';

export function getSimpleFormIdFromUrl(): EncryptedObjectIdString | undefined {
    const match = window.location.pathname.match(/\/form\/([A-Za-z0-9_-]{22})/);
    if (match && isEncryptedObjectIdString(match[1])) {
        return match[1] as EncryptedObjectIdString;
    }
    return undefined;
}
